import * as Yup from 'yup';
import { dateFromat, engNumChar } from 'components/Common/InputBox/validator';
import * as validator from 'components/Common/InputBox/validator';

Yup.addMethod(Yup.string, 'engNumChar', engNumChar);
Yup.addMethod(Yup.string, 'dateFromat', dateFromat);
Yup.addMethod(Yup.string, 'noSpaceInFront', validator.noSpaceInFront);

export const AnniversarySchema = () => {
  return Yup.object().shape({
    subject: Yup.string().required('MB_M_REQUIRED').noSpaceInFront(),
    date: Yup.string().required('MB_M_REQUIRED').dateFromat('BTY_W_T_DATE_FORMAT_ERROR'), // 필수값, 영문과 숫자만 가능 한글불가능, // 필수값
  });
};

export default AnniversarySchema;
